export interface PrivateIp {
  id: string;
  address: string;
  mask: string;
}

export interface DhcpServer {
  id: string;
  network: string;
  rangeStart: string;
  rangeEnd: string;
  wins: string;
  active: boolean;
}

export interface DhcpLease {
  id: string;
  ip: string;
  mac: string;
  reserved: boolean;
}

export interface DhcpOption {
  id: string;
  name: string;
  code: string;
  value: string;
}

export interface Lan {
  privateIps: PrivateIp[];
  dhcpServer: DhcpServer | null;
  leases: DhcpLease[];
  options: DhcpOption[];
}

export type Protocol = 'tcp' | 'udp';

export interface NatRule {
  id: string;
  protocol: Protocol;
  originIp: string;
  publicIp: string;
  publicPort: string;
  privateIp: string;
  privatePort: string;
}

export interface DmzEntry {
  publicIp: string;
  privateNetwork: string;
  privateLastOctet: string;
  redirectIcmp: boolean;
}

export interface FirewallPrive {
  natRules: NatRule[];
  dmz: DmzEntry[];
  publicIps: string[];
  wanIps: string[];
  privateNetworks: string[];
}

export interface DmzSaveEntry {
  publicIp: string;
  network: string;
  lastOctet: string;
  redirectIcmp: boolean;
}

export const PORT_PRESETS = [
  {label: 'FTP', value: '21'},
  {label: 'SSH', value: '22'},
  {label: 'Telnet', value: '23'},
  {label: 'SMTP', value: '25'},
  {label: 'Web (HTTP)', value: '80'},
  {label: 'POP3', value: '110'},
  {label: 'VNC', value: '5900'},
];

export type PublicAction = 'accept' | 'drop';

export interface PublicFirewallRule {
  id: string;
  protocol: Protocol;
  sourceIp: string;
  sourcePort: string;
  destinationIp: string;
  destinationPort: string;
  action: PublicAction;
}

export interface FirewallPublic {
  rules: PublicFirewallRule[];
  destinations: string[];
}

export type WlanBand = '2.4GHz' | '5GHz';
export type WlanMode = '2ghz' | '5ghz' | '6ghz';

export interface WlanInterface {
  id: string;
  name: string;
  mode: WlanMode;
  ssid: string;
  password: string;
  active: boolean;
  about?: string;
}

export interface L2tpParams {
  active: boolean;
  ipsecSecret: string;
}

export interface VpnAccount {
  id: string;
  login: string;
  password: string;
  remoteAddress: string | null;
}

export interface Vpn {
  l2tp: L2tpParams;
  subnet: string | null;
  accounts: VpnAccount[];
}

export const MAX_VPN_ACCOUNTS = 60;
export const RESERVED_LOGINS = ['remote', 'pppoe'];

export interface PingResult {
  destination: string;
  sent: number;
  received: number;
  lossPercent: number;
  minMs: number;
  maxMs: number;
  avgMs: number;
}

export interface TracerouteHop {
  hop: number;
  ip: string;
  reverseDns: string;
  latencyMs: number;
  status: string;
}
